import { TableCell } from "@material-ui/core";
import { useTableStyles } from "@saleor/autobooking/styles/tableStyles";
import { maybe } from "@saleor/misc";
import React from "react";

interface TableCellStatusProps {
  label: string;
  value: any | undefined;
  disabled?: boolean;
  textClass?: string;
}

export const TableCellStatus: React.FC<TableCellStatusProps> = props => {
  const { label, value, disabled, textClass } = props;
  const tblClasses = useTableStyles(props);

  return (
    <TableCell
      className={`${tblClasses.tableCellBody} ${tblClasses.colStatus}`}
    >
      <div>
        <div className={tblClasses.dataTitle}>{label}</div>
        <div className={`${tblClasses.textCenter}`}>
          {maybe(() => value && !disabled) ? (
            <span className={textClass ? textClass : ""}>{value}</span>
          ) : (
            "-"
          )}
        </div>
      </div>
    </TableCell>
  );
};

export default TableCellStatus;
